/**
 * Enumerates some input devices that can be tracked.(including status, posture and other information)
 */
export enum XRTrackedInputDevice {
  /** Controller */
  Controller,
  /** Left controller */
  LeftController,
  /** Right controller */
  RightController,
  /** Camera */
  Camera,
  /** Left camera */
  LeftCamera,
  /** Right camera */
  RightCamera,
  /** Head */
  LeftHand,
  /** Right hand */
  RightHand
}
